
type DocumentItem = {
  id: number;
  title: string;
  date?: string;
  
};

type DotCardProps = {
  item: DocumentItem;
  onUpload: (id: number) => void;
};

export default function DotCard({ item, onUpload }: DotCardProps) {

    
  return (
    <div
      className=" border w-[190px]  relative hover:shadow-lg 
      border-[#D2EBDB] 
      transition-all duration-200 hover:-translate-y-1 
      rounded-xl bg-white mb-1"
    >
         <div className="absolute top-0 left-0 w-5 h-full bg-[#D2EBDB] rounded-l-xl overflow-hidden"></div>
      <div className=" mb-2 pl-7 py-2">
        

        <div>
          <p className="text-sm font-semibold text-gray-800">
            {item.title}
          </p>

          <p className="text-xs text-gray-500">
            {item.date}
          </p>

          <div className="flex  items-center gap-2 pt-1">

<p className="text-xs text-purple-500">💻 Online</p>

<span className={` flex items-center gap-[3px]
    border border-green-500 bg-green-100
    text-xs font-medium text-green-500
    px-2 py-1 rounded-full `}>
 <span className="inline-block w-[7px] h-[7px] rounded-full bg-green-500"></span>
                      Completed
                    </span>
          </div>
        </div>
      </div>

     
    </div>
  );
}